import {createContext} from 'react'

export const CustomizableTabsContext = createContext({});
